(function () {
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  async function updateCartAttributes(attrs) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
    if (!res.ok) throw new Error('cart/update failed');
    return res.json();
  }

  function openModal(modal) { modal.hidden = false; }
  function closeModal(modal) { modal.hidden = true; }

  document.addEventListener('DOMContentLoaded', function () {
    const modal = qs('#DeliveryDiscountModal');
    const openBtn = qs('#DeliveryDiscountOpen');
    const applyBtn = qs('#DeliveryDiscountApply');
    const status = qs('#DeliveryDiscountStatus');

    if (!modal || !openBtn || !applyBtn) return;

    openBtn.addEventListener('click', function () {
      openModal(modal);
    });

    qsa('[data-close]', modal).forEach(function (el) {
      el.addEventListener('click', function () { closeModal(modal); });
    });

    applyBtn.addEventListener('click', async function () {
      const checked = qs('input[name="delivery_plan"]:checked', modal);
      if (!checked) return;

      const rate = checked.value;              // "0" | "3" | "5"
      const label = checked.dataset.label;     // "通常" | "+2営業日" | "+4営業日"

      status.textContent = '適用中です';
      applyBtn.disabled = true;

      try {
        await updateCartAttributes({
          delivery_discount_rate: rate,
          delivery_plan_label: label
        });

        // Functionsの割引をカート表示に反映させる最短手段
        window.location.reload();
      } catch (e) {
        status.textContent = '更新に失敗しました';
        applyBtn.disabled = false;
      }
    });

    // 任意：初回だけ自動表示（未選択ならポップアップ）
    const current = (qs('#DeliveryDiscountCurrentRate') || {}).textContent;
    if (current != null && String(current).trim() === '0') {
      // 自動表示したくない場合は、このブロックを削除してください
      // openModal(modal);
    }
  });
})();
